import React from 'react';
import { Tooltip, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Room, ViewListOutlined, ViewCarousel } from '@mui/icons-material';
import { useIntl } from 'react-intl';

import { isIdeasRequest } from '../../../../../../Utils/Post';
import { SteppablePostType } from '../../../../../../Utils/Types/Steps';

function TogglePostsView({
  post,
  setPostsView,
  postsView,
  defaultView,
}: {
  post: any;
  setPostsView: any;
  postsView: string;
  defaultView: string;
}) {
  const intl = useIntl();
  const postType = post?.type as SteppablePostType;
  const enableCarouselOption = isIdeasRequest(postType);

  const handlePostsViewToggle = (_event: any, value: any) => {
    if (value !== null) {
      setPostsView(value);
    }
  };

  const viewOptions: Record<string, any> = {
    ...(enableCarouselOption && {
      carousel: {
        label: intl.formatMessage({ id: 'TOGGLE_POSTS_VIEW.BUTTON_CAROUSEL' }),
        icon: <ViewCarousel />,
      },
    }),
    list: {
      label: intl.formatMessage({ id: 'TOGGLE_POSTS_VIEW.BUTTON_LIST' }),
      icon: <ViewListOutlined />,
    },
    map: {
      label: intl.formatMessage({ id: 'TOGGLE_POSTS_VIEW.BUTTON_MAP' }),
      icon: <Room />,
    },
  };

  const { [defaultView]: firstOption, ...otherOptions } = viewOptions;

  return (
    <ToggleButtonGroup
      color="primary"
      value={postsView}
      onChange={handlePostsViewToggle}
      aria-label={intl.formatMessage({ id: 'TOGGLE_POSTS_VIEW.BUTTON_GROUP' })}
      exclusive
    >
      <ToggleButton
        value={defaultView}
        aria-label={firstOption.label}
        key={defaultView}
        sx={{ padding: '15px' }}
      >
        <Tooltip title={firstOption.label} placement="top" arrow>
          {firstOption.icon}
        </Tooltip>
      </ToggleButton>

      {Object.entries(otherOptions).map(([key, option]) => (
        <ToggleButton value={key} aria-label={option.label} key={key} sx={{ padding: '15px' }}>
          <Tooltip title={option.label} placement="top" arrow>
            {option.icon}
          </Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

export default TogglePostsView;
